import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const CreateButtonContainer = styled.div`
    padding: 0 1.4rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
`;

const CreateButtonLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1.5rem;
    text-decoration: none;
    color: #ffffff;
    background-color: #d41117;
    transition: all 0.3s ease;
    border-radius: 0.95rem;
    font-weight: 500;
    font-size: 1.15rem;

    &:hover {
        color: #ffffff;
        background-color: #b50f14;
    }
`;

const CreateButton: React.FC = () => {
    return (
        <CreateButtonContainer>
            {/* eslint-disable-next-line */}
            <CreateButtonLink to="/project/0">New Project</CreateButtonLink>
        </CreateButtonContainer>
    );
};

export default CreateButton;
